import {
  getBoutiqueItemPublicPath,
  getDesignerItemPublicPath,
  getItemPublicPath,
} from './itemLinks';

const IMAGE_BASE =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://127.0.0.1:8080'
    : '';

const resolveImageUrl = (raw) => {
  if (!raw) return null;
  const value = typeof raw === 'string' ? raw : raw?.image;
  if (!value) return null;
  return value.startsWith('http') ? value : `${IMAGE_BASE}${value}`;
};

export const getOrderLineDetails = (line) => line?.item_details || {};

export const getOrderLineTitle = (line) => {
  const details = getOrderLineDetails(line);
  if (line?.title) return line.title;
  if (details.title) return details.title;
  if (details.item_name) return details.item_name;
  if (line?.line_kind === 'designer') return 'Designer listing';
  if (line?.line_kind === 'boutique') return 'Boutique listing';
  return 'Listing';
};

export const getOrderLineImageUrl = (line) => {
  const details = getOrderLineDetails(line);
  return (
    resolveImageUrl(details.image_url) ||
    resolveImageUrl(details.primary_image) ||
    resolveImageUrl(details.images?.[0]) ||
    resolveImageUrl(details.images?.[0]?.image) ||
    null
  );
};

export const getOrderLinePath = (line) => {
  const details = getOrderLineDetails(line);
  if (line?.line_kind === 'designer') return getDesignerItemPublicPath(details);
  if (line?.line_kind === 'boutique') return getBoutiqueItemPublicPath(details);
  if (details?.title && details?.category) return getItemPublicPath(details);
  if (details?.item_code) return getItemPublicPath(details);
  return '/pre-owned-items';
};

export const getOrderLineKindLabel = (line) => {
  if (line?.line_kind === 'designer') return 'Designer listing';
  if (line?.line_kind === 'boutique') return 'Boutique listing';
  return null;
};
